// extracted by mini-css-extract-plugin
export default {"JobManagement":"styles_JobManagement__kah84","container":"styles_container__aeOP6"};